import { render, staticRenderFns } from "./TableColgroup.vue?vue&type=template&id=247a6524&"
import script from "./TableColgroup.vue?vue&type=script&lang=js&"
export * from "./TableColgroup.vue?vue&type=script&lang=js&"
import style0 from "./TableColgroup.vue?vue&type=style&index=0&rel=stylesheet%2Fcss&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports